import { co2 } from './common';

export default {
  'consumption.co2': `${co2} emisiónes combinadas`,
  'consumption.energy': 'Consumo de potencia en ciclo de prueba combinado',
  'consumption.fuel': 'Consumo energético combinado',
  'footnotes.local': '',
  'footnotes.wltp': `En cumplimiento con las normas mexicanas aplicables. El alcance de
la presente información referente al rendimiento de combustible, relaciona valores obtenidos en condiciones controladas, las cuales pueden variar derivado de las condiciones ambientales, orografía, calidad del combustible, así como operación del vehículo automotor.`,
  'footnotes.nedc':
    'En cumplimiento con las normas mexicanas aplicables. El alcance de la presente información referente al rendimiento de combustible, relaciona valores obtenidos en condiciones controladas, las cuales pueden variar derivado de las condiciones ambientales, orografía, calidad del combustible, así como operación del vehículo automotor.', // `Los valores de ${co2} indicados han sido obtenidos de acuerdo con el procedimiento de ensayo “NEDC ${co2}“ según lo dispuesto en el art. 2 No1 Reglamento de aplicación (UE) 2017/1153.`
  'footnotes.emissions.appendix':
    'Para obtener más información sobre el consumo oficial de combustible y las emisiones de CO2 de autos de pasajeros, contacta tu distribuidor autorizado Mercedes-Benz.', // `Los datos no se refieren a un vehículo en particular y no forman parte de una oferta, sino que únicamente sirven para establecer comparativas entre distintos modelos. Para más información acerca del consumo de combustible oficial y de las emisiones de ${co2} se puede consultar la 'Guía de consumo de combustible y emisiones de ${co2} de nuevos vehículos' que está disponible sin coste en todos los puntos de venta y en IDAE en www.idae.es.`,
  'search.input.label': 'Término buscado/OnlineCode Configurator',
  'search.result.buy-online': 'Compra online',
  'search.results': 'Resultados no encontrados | {count} resultado | {count} resultados',
  'search.results.count': ' {count} resultados',
  'search.results.backup': 'No se han encontrado coincidencias exactas. Ver páginas relacionadas:',
  'search.results.none.summary':
    'No hay resultados disponibles para este término de búsqueda. Inténtalo de nuevo con otro término de búsqueda.',
  'search.show-more': 'Mostrar más',
  'search.unavailable': 'Búsqueda no disponible actualmente.',
  'search.result.new': 'Nuevo',

  didyoumean: '¿Quisiste decir?',
  all: 'Todos',
  configurator: 'Configura tu vehículo',
  collect: 'Collection y Accesorios',
  connect: 'Mercedes me Store',
  ncos: 'New Cars Online Store ',
  ucos: 'Used Cars Online Store',
  dealer_locator: 'Localizador de Distribuidores',
  passenger_cars: 'Autos de pasajeros',
  test_drive: 'Prueba de manejo',
  vans: 'Vanes',
  vehicles_search: 'Búsqueda de vehículos',
  video: 'Video',
  related_search: 'Búsquedas relacionadas',
  ACCESSORIES: 'Accesorios de coche',

  'search.result.consumption': 'Consumo',
  'watch.video': 'Vea el vídeo',
  'input.recently': 'Buscado recientemente',
  'input.help.title': '¿Qué puedes buscar?',
  'input.help.text':
    'Puedes realizar búsquedas indicando el tipo de vehículo, el modelo, códigos de configuración o bien buscar accesorios, otros productos e información',

  'input.placeholder': 'Tu búsqueda / Código online del configurador',

  // No results found
  'support.check':
    'Comprueba que no has cometido errores de ortografía, o inténtalo de nuevo con un término diferente.',
  'support.no.results': 'No hay resultados disponibles para este término de búsqueda.',
  'support.no.results.term': 'No se ha encontrado ningún resultado',
  'support.chat': '¿No has encontrado lo que estabas buscando? Acude a nuestro servicio de asistencia por',
  'support.chat.with.us': 'conversación online',

  'search.results.offer': 'Ofertas populares para "{query}":',
};
